import React, { useState } from "react";

const Introduction = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <>
      <section className="video-section">
        <div className="video-pattern" aria-hidden="true">
          <svg
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
          >
            <svg x="85%" y="20%" overflow="visible">
              <use
                href="#blob-1"
                fill="#FFA5BC"
                transform="scale(1.4)"
                opacity="0.15"
              ></use>
            </svg>
            <svg x="20%" y="80%" overflow="visible">
              <use
                href="#blob-2"
                fill="#B798F2"
                transform="scale(1.96)"
                opacity="0.15"
              ></use>
            </svg>
            <svg x="55%" y="50%" overflow="visible">
              <use
                href="#blob-1"
                fill="#E8EBFF"
                transform="scale(1.19)"
                opacity="0.5"
              ></use>
            </svg>
          </svg>
        </div>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="video-wrapper">
            <h2 className="section-title" style={{ marginBottom: "24px" }}>
              See How It Works
            </h2>

            <div
              className="video-thumb"
              onClick={() => setIsPlaying(true)}
              style={{ cursor: isPlaying ? "default" : "pointer" }}
            >
              {isPlaying ? (
                <iframe
                  src="https://player.vimeo.com/video/448103322?badge=0&autopause=0&player_id=0&app_id=58479"
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  title="Learning with 42courses"
                />
              ) : (
                <>
                  <img
                    src={require("../../../../../assets/images/landings/42courses-video-thumbnail.jpg")}
                    alt="42courses video thumbnail"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                  <div className="play-btn"></div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Introduction;
